<template>
  <div class="content">
    <el-drawer
      :title="$t('container.notice')"
      :visible.sync="drawer"
      :before-close="handleClose1"
      size="30%"
    >
      <div v-if="list.length > 0">
        <div
          v-for="(item, index) in list"
          :key="index"
          @click="showMessageDetail(item.Id)"
        >
          <el-card
            shadow="hover"
            class="messageBox"
            :class="item.IsRead === 1 ? 'isRead' : ''"
          >
            <div class="top" v-if="item.IsTop">{{ $t("container.top") }}</div>
            <h3>{{ item.Title }}</h3>
            <div>{{ item.MessageContent }}</div>
            <div class="time">
              <span>{{ item.ReleaseTime }}</span>
            </div>
          </el-card>
        </div>
        <div class="pages">
          <div class="btns">
            <p style="margin-right:20px;">
              {{
                $t("container.noticeText", {
                  number: count
                })
              }}
            </p>

            <el-button
              type="primary"
              round
              size="mini"
              style="margin-right:10px;"
              :disabled="page === 1"
              @click="previousPageAction"
              >{{ $t("container.previous") }}</el-button
            >
            <p style="margin-right:10px;">
              <span>{{ page }}</span>
              /{{ lastPage }}
            </p>
            <el-button
              type="primary"
              round
              size="mini"
              :disabled="page === lastPage || lastPage === 0"
              @click="nextPageAction"
              >{{ $t("container.next") }}</el-button
            >
          </div>
        </div>
      </div>
      <div v-else class="noMessage">
        <h3>{{ $t("container.noNotice") }}</h3>
      </div>
      <el-drawer
        :title="$t('container.noticeDetail')"
        append-to-body
        :visible.sync="innerDrawer"
        :before-close="handleClose2"
      >
        <el-card shadow="hover" class="messageBox">
          <h3>{{ messageDetail.Title }}</h3>
          <div>{{ messageDetail.MessageContent }}</div>
          <div class="time">
            <span>{{ messageDetail.ReleaseTime }}</span>
          </div>
        </el-card>
      </el-drawer>
    </el-drawer>

    <div class="bg" :class="{ bg1: imgBg }"></div>
    <div class="scroll-box" :class="{ 'no-scroll': imgBg }">
      <div
        class="nameAndLogout"
        v-if="name !== null && name !== '' && !isLoginPath"
      >
        <figure class="userImgBox" @click="userManage">
          <img
            class="ImgIcon"
            :src="userImgUrl && getuserImgUrl(userImgUrl)"
            :onerror="errorImg"
          />
        </figure>
        <span class="name">{{
          cUserInfo.NickName == "" ? cUserInfo.UserName : cUserInfo.NickName
        }}</span>
        <span class="narbarBtn" @click="gotoHome">{{
          $t("container.backHome")
        }}</span>

        <span class="narbarBtn" @click="userManage">{{
          $t("container.settings")
        }}</span>

        <span class="narbarBtn" @click="logout">{{
          $t("container.logout")
        }}</span>

        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('container.serviceEmail') + '：service@vancheen.com'"
          placement="bottom-end"
        >
          <a class="narbarBtn" @click="contactService">{{
            $t("container.contactService")
          }}</a>
        </el-tooltip>

        <span class="narbarBtn">
          <span @click="handleSetLanguage('en')" v-if="getLang() === 'zh'">
            English
          </span>
          <span @click="handleSetLanguage('zh')" v-else>
            中文
          </span>
        </span>

      </div>
      <div class="container">
        <slot></slot>
      </div>
    </div>

    <!-- 联系客服弹窗 -->
    <el-dialog
      :title="$t('container.tips')"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      center
    >
      <h3 style="margin-top:0px">{{ $t("container.serviceText") }}</h3>
      <el-select
        class="m-b-20"
        v-model="service.serviceType"
        :placeholder="$t('container.select')"
        style="width:100%"
      >
        <el-option
          v-for="item in serviceTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input
        type="textarea"
        :placeholder="$t('container.inputContent')"
        :autosize="{ minRows: 4 }"
        v-model="service.serviceContent"
      ></el-input>
      <h3>{{ $t("container.contactWay") }}</h3>
      <el-input
        :placeholder="$t('container.inputEmail')"
        v-model="service.serviceEmail"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="serviceSubmit">{{
          $t("container.submit")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { LOG_OUT } from "../store/mutation-types";
export default {
  name: "cContainer",
  props: {
    imgBg: {
      type: Boolean,
      default: false,
      isLoginPath: true
    }
  },
  data() {
    return {
      page: 1,
      count: 0,
      lastPage: 0,
      serviceTypeList: [
        { value: "1", label: this.$t("container.sOption1") },
        { value: "2", label: this.$t("container.sOption2") },
        { value: "3", label: this.$t("container.sOption3") }
      ],
      service: {
        serviceType: "", //服务类型
        serviceContent: "", //服务内容
        serviceEmail: "" //邮箱地址
      },
      dialogVisible: false, //联系客服弹窗
      innerDrawer: false,
      drawer: false,
      direction: "rtl",
      list: [],
      messageDetail: { Title: "", MessageContent: "", ReleaseTime: "" },
      name:
        localStorage.getItem("auth") && this.$store.getters.isLogging
          ? JSON.parse(localStorage.getItem("auth")).userName
          : null,
      errorImg:
        'this.src="' + require("@/assets/img/user/img_logo@2x.png") + '"'
    };
  },
  watch: {},
  beforeCreate() {
    // console.log(this.$route.path)
    if (this.$route.path === "/login") {
      this.isLoginPath = true;
    } else {
      this.isLoginPath = false;
    }
  },
  computed: {
    ...mapState({
      userImgUrl: state => state.cUser.cUserInfo.UserHeadPhoto,
      cUserInfo: state => state.cUser.cUserInfo
    })
  },
  created() {
    this.getCUser();
  },
  methods: {
    ...mapMutations([LOG_OUT]),
    ...mapActions(["getCUser", "setLanguage"]),
    getLang() {
      return this.$store.getters.getLanguage;
    },
    handleSetLanguage(lang) {
      this.setLanguage(lang);
      location.reload();
      if (lang == "en") {
        this.$message({
          message: "Switch Language Success",
          type: "success"
        });
      } else {
        this.$message({
          message: "切换语言成功",
          type: "success"
        });
      }
    },
    isLogin() {
      return this.$store.getters.isLogging;
    },
    logout() {
      this.LOG_OUT();
      this.gotoHome();
    },
    gotoHome() {
      this.$router.replace("/home");
    },
    userManage() {
      this.$route.path !== "/cUser/UserManage" &&
        this.$router.replace("/cUser/UserManage");
    },
    getuserImgUrl(userImgUrl) {
      return this.$api.formatImageUrl(userImgUrl);
    },
    message() {
      this.$router.replace("/index/messageList");
    },
    // 打开抽屉
    openMessageBox() {
      this.drawer = true;
      this.getPlatformMessage(this.page);
    },
    // 关闭外部抽屉
    handleClose1(done) {
      done();
    },
    // 关闭内部抽屉
    handleClose2(done) {
      done();
      this.getPlatformMessage(this.page);
    },
    // 弹窗关闭函数
    handleClose(done) {
      this.initServiceObj();
      done();
    },
    // 提交
    serviceSubmit() {
      if (
        this.service.serviceType == "" ||
        this.service.serviceContent == "" ||
        this.service.serviceEmail == ""
      ) {
        this.$message.error(this.$t("container.submitError"));
        return false;
      } else {
        this.dialogVisible = false;
      }
    },
    // 初始化表单
    initServiceObj() {
      for (let i in this.service) {
        this.service[i] = "";
      }
    },
    // 联系客服
    contactService() {
      this.$router.push({
        path: "/contactCustomerService",
        query: {
          Type: "C"
        }
      });
    },
    // 下一页
    nextPageAction() {
      this.getPlatformMessage(this.page + 1);
    },
    // 上一页
    previousPageAction() {
      this.getPlatformMessage(this.page - 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.pages {
  margin-top: 30px;
  height: 30px;
  width: 100%;
  .btns {
    // width: 150px;
    display: flex;
    height: 30px;
    align-items: center;
    float: right;
    margin-right: 10px;
  }
}
.noMessage {
  display: flex;
  justify-content: center;
  color: #22b196;
}
.m-b-10 {
  margin-bottom: 10px;
}
.m-b-20 {
  margin-bottom: 20px;
}
.content {
  height: 100%;
}
::v-deep .el-drawer__body {
  overflow: auto;
}
::v-deep.el-drawer__container ::-webkit-scrollbar {
  display: none;
}
.scroll-box {
  height: 100%;
  padding-top: 90px;
  padding-bottom: 90px;
  overflow: hidden;
  overflow-y: scroll;
}
.no-scroll {
  height: auto;
  overflow: initial;
  overflow-y: initial;
  .nameAndLogout {
    position: absolute;
    margin-top: -3.23rem;
    right: 12%;
    color: #ffffff;
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -moz-flex;
    align-items: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    .name {
      padding-right: 25px;
      border-right: 1px solid #fff;
      border-width: 2px;
    }
    .narbarBtn {
      margin-left: 25px;
      cursor: pointer;
      ::v-deep .el-badge__content {
        height: 20px;
        width: 20px;
        padding: 0px;
      }
    }
    .narbarBtn {
      text-decoration: none;
      &:link {
        text-decoration: none;
      }
      &:visited {
        text-decoration: none;
      }
      &:hover {
        text-decoration: none;
      }
      &:active {
        text-decoration: none;
      }
      &:focus {
        text-decoration: none;
      }
    }
    .userImgBox {
      margin: 0;
      padding: 0;
      margin-right: 15px;
      .ImgIcon {
        width: 2.7rem;
        height: 2.7rem;
        line-height: 2.7rem;
        border-radius: 100%;
        object-fit: cover;
        box-shadow: 0 0 5px 0 #25b9ff;
        -webkit-box-shadow: 0 0 5px 0 #25b9ff;
        cursor: pointer;
      }
    }
  }
}
.bg {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: linear-gradient(#71d284, #02aaa4);
  z-index: -99;

  &.bg1 {
    background-image: url("../assets/img/img_bg.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: 0 -500px;
    min-height: 700px;
    position: absolute;
  }
}

.container {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  background-color: white;
  min-height: 100%;
  border-radius: 20px;
  position: relative;
  box-shadow: 0 0 50px 0 rgba(103, 182, 206, 0.27);
  overflow: hidden;
}
.isRead {
  background-color: #f1f3f4;
}
.messageBox {
  position: relative;
  width: 99%;
  margin-top: 10px;
  border-radius: 8px;
  min-height: 150px;
  cursor: pointer;

  .time {
    position: absolute;
    bottom: 5px;
    right: 10px;
    display: flex;
    justify-content: flex-end;
  }
  .top {
    position: absolute;
    top: 0px;
    right: 0px;
    height: 20px;
    border-radius: 8px;
    background-color: red;
    color: white;
    text-align: center;
    // font-weight: bold;
    width: 12%;
    font-size: 13px;
    line-height: 20px;
  }
}

@media (min-width: 1576px) {
  .container {
    max-width: 1540px;
  }
}

@media (min-width: 1768px) {
  .container {
    max-width: 1720px;
  }
}

@media (min-width: 1992px) {
  .container {
    max-width: 1960px;
  }
}

@media (min-width: 2200px) {
  .container {
    max-width: 2140px;
  }
}

@media (min-width: 2920px) {
  .container {
    max-width: 2720px;
  }
}
</style>
